module.exports = __webpack_public_path__ + "img/help25.796208f7.png";